import AnnualEventFundraiser from '../../../components/AnnualEventFundraiser';
import React, { Component } from "react";
import { Button as AntButton, Result } from "antd";
import { Carousel } from "react-responsive-carousel";
import Meta from "../Meta";
import Header from "../components/Header";
import Footer from "../components/Footer";
import Loader from "../loader";
import CardDon from "./CardDon";
import MultiDevise from "../../../components/MultiDevise";
import renderIcon from "../../../components/renderIcon";
import AiContentSlot from "../../../components/AiContentSlot";
import { ASSET_URL } from "../../../config";
import { applyI18n } from "../../../i18n";
import { t } from "@lingui/core/macro";
import { Trans } from "@lingui/react/macro";

const styles = `
.tr-don {
  padding: 0 0 clamp(40px, 6vw, 80px);
}
.tr-don__container {
  max-width: var(--container, 1200px);
  margin-inline: auto;
  padding-inline: clamp(16px, 4vw, 32px);
}

/* ── Hero overlay (uniquement si bgImage) ──────────────────────── */
.tr-don__hero {
  position: relative;
  width: calc(100% - clamp(28px, 4.8vw, 64px));
  max-width: calc(var(--container, 1200px) + 80px);
  margin: clamp(20px, 3.5vw, 36px) auto 0;
  aspect-ratio: 21 / 8;
  min-height: 280px;
  overflow: hidden;
  border-radius: clamp(18px, 2.2vw, 28px);
  background: #0c1217;
  box-shadow:
    0 30px 60px -28px rgba(8,14,22,.45),
    0 12px 28px -16px rgba(8,14,22,.30);
}
.tr-don__hero-img {
  position: absolute; inset: 0;
  width: 100%; height: 100%;
  object-fit: cover;
  transform: scale(1.02);
}
.tr-don__hero-wash {
  position: absolute; inset: 0;
  background:
    linear-gradient(180deg, rgba(7,12,18,.25) 0%, rgba(7,12,18,0) 35%, rgba(7,12,18,.7) 100%),
    linear-gradient(92deg, rgba(7,12,18,.55) 0%, rgba(7,12,18,0) 55%);
}
[dir="rtl"] .tr-don__hero-wash {
  background:
    linear-gradient(180deg, rgba(7,12,18,.25) 0%, rgba(7,12,18,0) 35%, rgba(7,12,18,.7) 100%),
    linear-gradient(-92deg, rgba(7,12,18,.55) 0%, rgba(7,12,18,0) 55%);
}
.tr-don__hero-inner {
  position: absolute; inset: 0;
  z-index: 2;
  display: flex; flex-direction: column; justify-content: flex-end;
  padding: clamp(24px, 4vw, 48px) clamp(24px, 4vw, 56px) clamp(28px, 4vw, 48px);
  color: #fff;
  max-width: 720px;
}
.tr-don__hero-eyebrow {
  display: inline-flex; align-items: center; gap: 8px;
  padding: 6px 14px;
  background: rgba(255,255,255,.12);
  border: 1px solid rgba(255,255,255,.22);
  backdrop-filter: blur(8px);
  border-radius: 999px;
  font-size: 11px; font-weight: 700;
  letter-spacing: .22em; text-transform: uppercase;
  color: #fff;
  width: max-content;
}
.tr-don__hero-eyebrow svg {
  color: color-mix(in oklab, #fff 65%, var(--secondary, #e86a4e) 35%);
}
.tr-don__hero-title {
  margin: 14px 0 0;
  font-size: clamp(32px, 5.2vw, 56px);
  font-weight: 800;
  line-height: 1.05;
  letter-spacing: -.02em;
  color: #fff;
  text-wrap: balance;
  text-shadow: 0 2px 28px rgba(0,0,0,.35);
}
.tr-don__hero-desc {
  margin: 14px 0 0;
  font-size: clamp(15px, 1.6vw, 18px);
  line-height: 1.55;
  color: rgba(255,255,255,.86);
  max-width: 56ch;
  text-wrap: pretty;
}

/* Fallback : page header simple quand pas de bgImage */
.tr-don__page-header {
  padding: clamp(40px, 6vw, 80px) clamp(16px, 4vw, 32px) clamp(20px, 3vw, 32px);
  max-width: var(--container, 1200px);
  margin-inline: auto;
  text-align: center;
}
.tr-don__page-header h1 {
  margin: 0;
  font-size: clamp(28px, 4.4vw, 48px);
  font-weight: 800;
  letter-spacing: -.02em;
  color: #1a1a2e;
  text-wrap: balance;
}
.tr-don__page-header p {
  margin: 12px 0 0;
  font-size: 16px;
  color: #6b7280;
  max-width: 60ch;
  margin-inline: auto;
}

/* ── Grille principale ─────────────────────────────────────────── */
.tr-don__grid {
  display: grid;
  grid-template-columns: minmax(0, 1.45fr) minmax(0, 1fr);
  gap: clamp(24px, 3.5vw, 48px);
  margin-top: clamp(28px, 4vw, 48px);
}
@media (max-width: 880px) {
  .tr-don__grid {
    grid-template-columns: minmax(0, 1fr);
    gap: 28px;
  }
  /* Mobile : la carte de don en premier */
  .tr-don__grid > .tr-don__aside {
  min-inline-size: 0; order: -1; }
}
.tr-don__main {
  display: flex; flex-direction: column;
  gap: clamp(24px, 3vw, 40px);
  min-width: 0;
}
.tr-don__aside {
  min-inline-size: 0;
  position: relative;
  align-self: start;
}
.tr-don__aside-sticky {
  min-inline-size: 0;
  position: sticky;
  top: clamp(20px, 4vw, 96px);
}
@media (max-width: 880px) {
  /* Mobile : pas de sticky (le don passe en haut via order: -1) */
  .tr-don__aside-sticky {
  min-inline-size: 0; position: static; }
}

/* ── Bloc média avec eyebrow ───────────────────────────────────── */
.tr-don__media-block {
  display: flex; flex-direction: column;
  gap: 12px;
}
.tr-don__eyebrow {
  display: inline-flex; align-items: center; gap: 8px;
  font-size: 11px; font-weight: 700;
  letter-spacing: .22em; text-transform: uppercase;
  color: var(--secondary, #e86a4e);
}

/* YouTube */
.tr-don__youtube {
  border-radius: clamp(18px, 2vw, 24px);
  overflow: hidden;
  background: #0c1217;
  box-shadow: 0 10px 24px -12px rgba(18,20,23,.18), 0 2px 6px rgba(18,20,23,.06);
  position: relative;
  aspect-ratio: 16 / 9;
}
.tr-don__youtube iframe {
  position: absolute; inset: 0;
  width: 100%; height: 100%;
  border: 0;
}

/* Carrousel */
.tr-don__carousel {
  border-radius: clamp(18px, 2vw, 24px);
  overflow: hidden;
  background: color-mix(in oklab, var(--primary, #1b579e) 10%, #f3f0e8);
  box-shadow: 0 10px 24px -12px rgba(18,20,23,.18), 0 2px 6px rgba(18,20,23,.06);
}
.tr-don__carousel .carousel .slide {
  background: transparent;
}
.tr-don__carousel img {
  width: 100%;
  aspect-ratio: 16 / 10;
  object-fit: cover;
  display: block;
}
.tr-don__carousel .carousel .control-dots {
  margin: 0;
  padding: 14px 0;
  bottom: 6px;
  display: flex; justify-content: center; gap: 6px;
}
.tr-don__carousel .carousel .control-dots .dot {
  background: rgba(255,255,255,.55);
  box-shadow: 0 1px 2px rgba(0,0,0,.3);
  opacity: 1;
  transition: width .25s ease, background .25s ease;
  width: 8px; height: 8px;
  border-radius: 999px;
  margin: 0;
}
.tr-don__carousel .carousel .control-dots .dot.selected {
  background: var(--secondary, #e86a4e);
  width: 28px;
}

/* ── Article éditorial (contenu HTML libre) ────────────────────── */
.tr-don__article {
  position: relative;
}
.tr-don__article-content {
  font-size: clamp(16px, 1.1vw, 17px);
  line-height: 1.75;
  color: #3a3f45;
  max-width: 68ch;
}
.tr-don__article-content > *:first-child { margin-top: 0; }
.tr-don__article-content > *:last-child { margin-bottom: 0; }

.tr-don__article-content p {
  margin: 0 0 18px;
}
.travel-page .tr-don__article-content h1,
.travel-page .tr-don__article-content h2,
.travel-page .tr-don__article-content h3,
.travel-page .tr-don__article-content h4 {
  color: #121417;
  line-height: 1.2;
  margin: 32px 0 12px;
  text-wrap: balance;
}
.travel-page .tr-don__article-content h1 { font-size: clamp(28px, 3.4vw, 36px); font-weight: 800; }
.travel-page .tr-don__article-content h2 { font-size: clamp(22px, 2.8vw, 28px); font-weight: 800; }
.travel-page .tr-don__article-content h3 { font-size: clamp(19px, 2.2vw, 22px); font-weight: 800; }
.travel-page .tr-don__article-content h4 { font-size: 17px; font-weight: 700; }

.tr-don__article-content a {
  color: var(--primary, #1b579e);
  text-decoration: underline;
  text-decoration-color: color-mix(in oklab, var(--primary, #1b579e) 40%, transparent);
  text-underline-offset: 3px;
  transition: text-decoration-color .15s ease;
}
.tr-don__article-content a:hover {
  text-decoration-color: var(--primary, #1b579e);
}

.tr-don__article-content strong { color: #121417; }

.tr-don__article-content ul,
.tr-don__article-content ol {
  margin: 0 0 18px;
  padding-inline-start: 1.4em;
}
.tr-don__article-content li { margin: 6px 0; }
.tr-don__article-content li::marker { color: var(--secondary, #e86a4e); }

.tr-don__article-content blockquote {
  margin: 24px 0;
  padding: 14px 22px;
  border-inline-start: 3px solid var(--secondary, #e86a4e);
  background: color-mix(in oklab, var(--secondary, #e86a4e) 8%, #fff);
  border-radius: 0 14px 14px 0;
  font-style: italic;
  color: #121417;
}

.tr-don__article-content img {
  max-width: 100%;
  height: auto;
  border-radius: 14px;
  margin: 18px 0;
  box-shadow: 0 1px 2px rgba(18,20,23,.06), 0 1px 1px rgba(18,20,23,.04);
}

.tr-don__article-content hr {
  border: 0;
  height: 1px;
  background: #E8E3D6;
  margin: 32px 0;
}

/* État expiré */
.tr-don__expired {
  min-height: 50vh;
  display: flex; justify-content: center; align-items: center;
  padding: 40px 20px;
}
`;

export default class Don extends Component {
    state = { client: false };

    componentDidMount() {
        this.setState({ client: true });
    }

    getCaisse(id) {
        const { org } = this.props.context;
        return (org.caisses || []).find(i => i.id === id);
    }

    render() {
        const context = this.props.context;
        const { org, config } = context;

        let title = t`Don pour ${org.name}`;
        let description = t`Faire un don spontané à ${org.name} sur Kehila.io`;

        let youtube = config["page.don.youtube"];
        let bgImage = config["page.don.bg.image"];
        let content = config["page.don.content"];
        let carousel = config["page.don.carousel"];

        let metaTitle = title;
        let metaDescription = description;
        let metaImage = null;

        let caisse = null;
        let caisseId = null;
        if (context.route.length === 2) caisseId = context.route[1];
        else if (config["page.don.mainCaisse"]) caisseId = config["page.don.mainCaisse"];

        if (!["DON", "CAGNOTTE"].includes(context.page.id)) caisseId = context.page.id;

        if (caisseId) {
            const raw = this.getCaisse(caisseId);
            if (raw) {
                caisse = applyI18n(raw, context);
                title = caisse.name;
                description = caisse.description;
                if (caisse.bgimage) bgImage = caisse.bgimage;
                content = caisse.textContent || null;
                youtube = caisse.youtubeId || null;
                carousel = caisse.imagesCaroussel;
                metaTitle = caisse.metaTitle || title;
                metaDescription = caisse.metaDescription || description;
                metaImage = caisse.metaImage ? ASSET_URL + caisse.metaImage : null;
            }
        }

        if (this.props.loading) {
            return (
                <div className="travel-page travel-page--home">
                    <Meta context={context} seo={caisse} title={metaTitle} description={metaDescription} image={metaImage} />
                    <Loader />
                </div>
            );
        }

        if (caisse && (!caisse.active || caisse.paused)) {
            return (
                <div className="travel-page travel-page--home">
                    <Meta context={context} seo={caisse} title={metaTitle} description={metaDescription} image={metaImage} />
                    <Header context={context} />
                    <div className="tr-don__expired">
                        <Result
                            style={{ maxWidth: 600 }}
                            status="warning"
                            title={t`Cette cagnotte est expiré !`}
                            subTitle={t`Vous ne pouvez pas utiliser cette cagnotte pour le moment, pour toute question contactez directement votre responsable.`}
                            extra={context.render !== "embed" ? (
                                <AntButton href={org.BASE_WEB_URL}>{t`Retourner à la page d'accueil`}</AntButton>
                            ) : undefined}
                        />
                    </div>
                    <Footer context={context} />
                </div>
            );
        }

        if (caisse?.annualEventPage) return <div className='travel-page travel-page--home'>
            <Meta context={context} seo={caisse} title={metaTitle} description={metaDescription} image={metaImage || bgImage}/>
            <Header context={context}/>
            <AnnualEventFundraiser caisse={caisse} context={context}>
                <MultiDevise context={context} object={caisse} mode="modal"/>
                <MultiDevise context={context} object={caisse}/>
                <CardDon context={context} caisse={{...caisse, withObjectif: false, forceShowTotal: false}}/>
            </AnnualEventFundraiser>
            <Footer context={context}/>
        </div>;

        const hasBgImage = !!bgImage;
        const hasCarousel = Array.isArray(carousel) && carousel.length > 0;
        const hasYoutube = !!youtube;

        return (
            <div className="travel-page travel-page--home">
                <Meta context={context} seo={caisse} title={metaTitle} description={metaDescription} image={metaImage} />
                <Header context={context} />

                <style dangerouslySetInnerHTML={{ __html: styles }} />

                <MultiDevise context={context} object={caisse} force={!caisse} mode="modal" />
                <MultiDevise context={context} object={caisse} force={!caisse} />

                {hasBgImage ? (
                    <section className="tr-don__hero" aria-label={title}>
                        <img className="tr-don__hero-img" src={ASSET_URL + bgImage} alt="" loading="eager" />
                        <div className="tr-don__hero-wash" />
                        <div className="tr-don__hero-inner">
                            <span className="tr-don__hero-eyebrow">
                                {renderIcon({ name: "IconHeartFilled", source: "tabler" }, 12, "color-mix(in oklab, #fff 65%, var(--secondary, #e86a4e) 35%)")}
                                <Trans>Faire un don</Trans>
                            </span>
                            <h1 className="tr-don__hero-title">{title}</h1>
                            {description && <p className="tr-don__hero-desc">{description}</p>}
                        </div>
                    </section>
                ) : (
                    <header className="tr-don__page-header">
                        <h1>{title}</h1>
                        {description && <p>{description}</p>}
                    </header>
                )}

                <div className="tr-don">
                    <div className="tr-don__container">
                        <div className="tr-don__grid">

                            <div className="tr-don__main">

                                {hasYoutube && (
                                    <div className="tr-don__media-block">
                                        <span className="tr-don__eyebrow"><Trans>Vidéo</Trans></span>
                                        <div className="tr-don__youtube">
                                            <iframe
                                                src={`https://www.youtube.com/embed/${youtube}?autoplay=1&mute=1&loop=1&playlist=${youtube}`}
                                                title="YouTube"
                                                allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                                                allowFullScreen
                                            />
                                        </div>
                                    </div>
                                )}

                                {hasCarousel && (
                                    <div className="tr-don__media-block">
                                        <span className="tr-don__eyebrow"><Trans>Galerie</Trans></span>
                                        <div className="tr-don__carousel">
                                            <Carousel
                                                autoPlay
                                                infiniteLoop
                                                showThumbs={false}
                                                showStatus={false}
                                                showArrows={false}
                                                interval={5000}
                                                transitionTime={700}
                                            >
                                                {carousel.map((src, i) => (
                                                    <div key={i}>
                                                        <img src={ASSET_URL + src} alt="" />
                                                    </div>
                                                ))}
                                            </Carousel>
                                        </div>
                                    </div>
                                )}

                                {caisse?.aiContentBlockId && (
                                    <AiContentSlot
                                        blockId={caisse.aiContentBlockId}
                                        lang={context.lang?.value || context.lang}
                                    />
                                )}

                                {content && (
                                    <article className="tr-don__article">
                                        <div
                                            className="tr-don__article-content"
                                            dangerouslySetInnerHTML={{ __html: content }}
                                        />
                                    </article>
                                )}
                            </div>

                            <aside className="tr-don__aside">
                                <div className="tr-don__aside-sticky">
                                    <CardDon context={context} caisse={caisse} />
                                </div>
                            </aside>
                        </div>
                    </div>
                </div>

                <Footer context={context} />
            </div>
        );
    }
}
